export default "__VITE_ASSET__C7oe2JB2__"